"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsHexadecimalValidator {
    isValid(input) {
        if (input) {
            return validatorJS.isHexadecimal(input);
        }
        return false;
    }
}
exports.IsHexadecimalValidator = IsHexadecimalValidator;
//# sourceMappingURL=IsHexadecimalValidator.js.map